<template>
  <section class="features-section">
      <h2 class="section-title">Почему MyVPS?</h2>
      <ul class="features-grid">
        <li class="feature-card feature-card--grey">
          <p>Высокая скорость</p>
          <img src="@/assets/images/android/features/speed.svg" alt="Высокая скорость">
        </li>
        <li class="feature-card feature-card--beige">
          <p>Без сбора данных</p>
          <img src="@/assets/images/android/features/privacy.svg" alt="Без сбора данных">
        </li>
        <li class="feature-card feature-card--orange">
          <p>Без рекламы</p>
          <img src="@/assets/images/android/features/adblock.svg" alt="Без рекламы">
        </li>
        <li class="feature-card feature-card--purple">
          <p>Без регистрации</p>
          <img src="@/assets/images/android/features/register.svg" alt="Без регистрации">
        </li>
        <li class="feature-card feature-card--blue">
          <p>Подключение в один клик</p>
          <img src="@/assets/images/android/features/click.svg" alt="Подключение в один клик">
        </li>
        <li class="feature-card feature-card--grey">
          <p>Пробный период 7 дней</p>
          <img src="@/assets/images/android/features/trial.svg" alt="Пробный период 7 дней">
        </li>
        <li class="feature-card feature-card--beige">
          <p>Защищённый доступ к сети</p>
          <img src="@/assets/images/android/features/lock.svg" alt="Защищённый доступ к сети">
        </li>
        <li class="feature-card feature-card--orange">
          <p>Устойчивость к взлому</p>
          <img src="@/assets/images/android/features/shield.svg" alt="Устойчивость к взлому">
        </li>
        <li class="feature-card feature-card--purple">
          <p>10Gb серверы по всему миру</p>
          <img src="@/assets/images/android/features/server.svg" alt="10Gb серверы по всему миру">
        </li>
        <li class="feature-card feature-card--blue">
          <p>Круглосуточная техподдержка</p>
          <img src="@/assets/images/android/features/support.svg" alt="Круглосуточная техподдержка">
        </li>
      </ul>
    </section>
</template>

<script setup>

</script>

<style scoped>
 .features-section {
  width: 100%;
  background: white;
  padding: 32px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
    .features-grid {
      display: flex; flex-direction: column; gap: 16px;
      width: 97%; max-width: 500px; margin-bottom: 18px;
    }
    .feature-card {
      font-size: 16px;
      display: flex; align-items: center; justify-content: space-between;
      padding: 16px; border-radius: 12px; color: #1B1B27;
    }
    .feature-card p { margin: 0; font-size: 18px; flex: 1; font-size: 16px }
    .feature-card img { width: 48px; height: 48px; margin-left: 16px; }
    .feature-card--grey   { background: #A0A8B9; color: #fff; }
    .feature-card--beige  { background: #F1F0E9; }
    .feature-card--orange { background: #FFD99B; }
    .feature-card--purple { background: #EBEAFF; }
    .feature-card--blue   { background: #CDEFFD; }
</style>